document.addEventListener('DOMContentLoaded', function() {
  // Show the subscription plan and one-time plan blocks for the current dog size
  if (typeof curDogSize !== 'undefined') {
    // Select elements with the classes and make them visible
    const subscriptionPlan = document.querySelectorAll('.subscr-plan.subscr-plan-' + curDogSize);
    const oneTimePlan = document.querySelectorAll('.subscr-plan.ontp-plan-' + curDogSize);
    
    if (subscriptionPlan) {
        subscriptionPlan.forEach((subscriptionPlanElem) => {
            subscriptionPlanElem.classList.add("visible");
        });      
    }
    
    if (oneTimePlan) {
        oneTimePlan.forEach((oneTimePlanElem) => {
            oneTimePlanElem.classList.add("visible");
        });      
    }
    
    console.log('Showing plans for dog size:', curDogSize);
  } else {
    console.warn('curDogSize variable is not defined');
  }
  
  // Dog size selector functionality
  const dogSizeItems = document.querySelectorAll('.frequency-big__item');
  
  dogSizeItems.forEach(item => {
    item.addEventListener('click', function() {
      // 1. Remove active class from all size items and add to clicked one
      document.querySelectorAll('.frequency-big__item').forEach(i => i.classList.remove('active'));
      this.classList.add('active');
      
      // 2. Show subscription plans based on dog size
      const dogSize = this.getAttribute('data-dogsize');
      
      // Hide all plans first
      document.querySelectorAll('.subscr-plan').forEach(plan => {
        plan.classList.remove('visible');
      });
      
      // Show plans with matching dog size
      document.querySelectorAll('.subscr-plan[data-dogsize="' + dogSize + '"]').forEach(plan => {
        plan.classList.add('visible');
      });
      
      // Update global variable for dog size
      curDogSize = dogSize;
      
      // 3. Click the first visible subscription plan in the active tab content
      const activeTabContent = document.querySelector('.frequency-tab-content.active');
      if (activeTabContent) {
        const firstVisiblePlan = activeTabContent.querySelector('.subscr-plan.visible');
        if (firstVisiblePlan) {
          firstVisiblePlan.click();
        }
      }

      var tabprc = document.querySelectorAll('.tabprc');
      tabprc.forEach(tabprcitem => {
        tabprcitem.style.display = 'none';

        let tabprcitemS = tabprcitem.getAttribute('data-dogsize');
        if (tabprcitemS == dogSize) {
          tabprcitem.style.display = 'inline';
        }
      });

    });
  });
  
  // Tab functionality
  const frequencyTabs = document.querySelectorAll('.frequency-tab');
  
  frequencyTabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // 1. Remove active class from all tabs and add to clicked one
      document.querySelectorAll('.frequency-tab').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // 2. Show corresponding content based on data-tab attribute
      const tabId = this.getAttribute('data-tab');
      
      // Hide all tab contents
      document.querySelectorAll('.frequency-tab-content').forEach(content => {
        content.classList.remove('active');
      });
      
      // Show the matching tab content
      const activeContent = document.querySelector('.frequency-tab-content[data-content="' + tabId + '"]');
      if (activeContent) {
        activeContent.classList.add('active');
        
        // 3. Auto-click the first visible subscription plan in this tab content
        const firstVisiblePlan = activeContent.querySelector('.subscr-plan.visible');
        if (firstVisiblePlan) {
          firstVisiblePlan.click();
        }
      }
      
    });
  });
  
  // Add click event listeners to all subscription plan blocks
  const allSubscrPlans = document.querySelectorAll('.subscr-plan');
  
  allSubscrPlans.forEach(plan => {
    plan.addEventListener('click', function() {
      // 1. Remove 'active' class from all plans and add it to the clicked one
      document.querySelectorAll('.subscr-plan').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      
      // 2. Get variant ID and select the matching option in the variant select dropdown
      const variantId = this.getAttribute('varid');
      const variantSelect = document.getElementById('variant_select');
      
      if (variantSelect && variantId) {
        const options = variantSelect.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].value === variantId) {
            variantSelect.selectedIndex = i;
            // Dispatch change event to trigger any listeners
            const event = new Event('change', { bubbles: true });
            variantSelect.dispatchEvent(event);
            break;
          }
        }
      }
      
      // 3. Handle selling plan ID
      const sellingPlanInput = document.getElementById('selling-plan-input');
      const sellingPlanId = this.getAttribute('splanid');
      
      if (sellingPlanInput) {
        if (sellingPlanId && sellingPlanId.trim() !== '') {
          sellingPlanInput.value = sellingPlanId;
        } else {
          sellingPlanInput.value = '';
        }
      }
      
      // 4. Update Add to Cart button text based on availability and price
      const addToCartButton = document.getElementById('AddToCart');
      const isAvailable = this.getAttribute('available');
      const price = this.getAttribute('splanprice');
      
      if (addToCartButton && price) {
        if (isAvailable === 'true') {
          addToCartButton.innerHTML = btnTextaddtocart + ' - ' + price;
        } else {
          addToCartButton.innerHTML = btnTextsold + ' - ' + price;
        }
      }

      const splanpriceperday = this.getAttribute('splanpriceperday');
      if (splanpriceperday) {
        const onLoadPlanPricePerDay = document.getElementById('onLoadPlanPricePerDay');
        if (onLoadPlanPricePerDay) {
          onLoadPlanPricePerDay.innerHTML = splanpriceperday;
        }
      }
    });
  });
  
  // Initially activate the first tab if one exists
  const firstTab = document.querySelector('.frequency-tab');
  if (firstTab) {
    firstTab.click();
  }
});